import React, { useState } from 'react'
import { Trans, t } from '@lingui/macro'
import { ButtonPrimary, ButtonClean, Modal } from 'front-end/src/components'

import Form, { FormRow } from '../../../components/common/form/Form'
import Label from '../../../components/common/form/label/Label'
import Input from '../../../components/common/form/input/Input'
import Textarea from '../../../components/common/form/textarea/Textarea'

import { navigateTo } from '../../../app/util/appHistory'
import ColorPickerButton from '../../../components/common/color-picker-button/ColorPickerButton'
import { useCreateDashboardMutation } from './NewDashboardModal.codegen'
import { linkBuilder } from 'shared/linkBuilder'

interface Props {
  onHide: () => void
  refreshDashboards: () => void
}

export const NewDashboardModal = ({ onHide, refreshDashboards }: Props) => {
  const [title, setTitle] = useState('')
  const [description, setDescription] = useState('')
  const [color, setColor] = useState('')

  const [createDashboardFn] = useCreateDashboardMutation({
    onCompleted: (data) => {
      onHide()
      refreshDashboards()
      const dashboardId = data?.admin?.createDashboard?.id

      if (dashboardId) {
        navigateTo(linkBuilder.dashboardManage(dashboardId))
      }
    }
  })

  return (
    <Modal
      show={true}
      onHide={onHide}
      header={t`Create a new Dashboard`}
      controls={[
        <ButtonClean key={1} onClick={onHide}>
          <Trans>Cancel</Trans>
        </ButtonClean>,
        <ButtonPrimary
          key={2}
          className="Button__next"
          onClick={async () => {
            await createDashboardFn({
              variables: { title, description, color }
            })
          }}
        >
          <Trans>Create</Trans>
        </ButtonPrimary>
      ]}
    >
      <Form>
        <FormRow>
          <Label htmlFor="dashboard_name">
            <Trans>Name</Trans>
          </Label>
          <Input
            className="Input__topicName"
            id="dashboard_name"
            fullWidth
            placeholder={t`Name of the dashboard`}
            onChange={(val) => {
              setTitle(val)
            }}
            value={title}
          />
        </FormRow>
        <FormRow>
          <Label htmlFor="purpose_statement">
            <Trans>Purpose Statement</Trans>
          </Label>
          <Textarea
            id="purpose_statement"
            fullWidth
            placeholder={t`Describe how this dashboard will be useful`}
            onChange={(val) => {
              setDescription(val)
            }}
            value={description}
          />
        </FormRow>
        <FormRow>
          <Label htmlFor="color">
            <Trans>Colour of icon</Trans>
          </Label>
          <ColorPickerButton
            color={color || '#00bb77'}
            onChange={(value) => {
              setColor(value)
            }}
          />
        </FormRow>
      </Form>
    </Modal>
  )
}
